import { api, buildQueryParams, URLs } from '@/libs/api'
import type { ApiResponse, Product, ProductListData, ProductListParams } from '@/libs/interfaces'
import { IS_MOCK_MODE } from '@/libs/mocks/config'
import { productsApiMock } from '@/libs/mocks/handlers/products'

const productsApiReal = {
  list: (params?: ProductListParams): Promise<ProductListData> => {
    const { orgID, storeID, ...queryParams } = params || {}
    const query = buildQueryParams(queryParams)
    return api
      .get<ApiResponse<ProductListData>>(URLs.Products.list(orgID ?? '', storeID ?? '', query))
      .then((response) => response.data.data)
  },
  getById: (params: Partial<Product>): Promise<Product> =>
    api
      .get<ApiResponse<Product>>(URLs.Products.byID(params?.orgID || '', params?.productID || ''))
      .then((response) => response.data.data),

  create: (data: Partial<Product>): Promise<Product> =>
    api
      .post<ApiResponse<Product>>(URLs.Products.create(data?.orgID || ''), data)
      .then((response) => response.data.data),

  update: (data: Partial<Product>): Promise<Product> =>
    api
      .put<
        ApiResponse<Product>
      >(URLs.Products.update(data.orgID || '', data?.productID || '', data?.type || ''), data)
      .then((response) => response.data.data),

  delete: (params: Partial<Product>): Promise<void> =>
    api
      .delete<
        ApiResponse<void>
      >(URLs.Products.delete(params?.orgID || '', params?.productID || '', params.type || ''))
      .then((response) => response.data.data),
}

export const productsApi: typeof productsApiReal = IS_MOCK_MODE ? productsApiMock : productsApiReal
